module.exports = __webpack_public_path__ + "img/EE.bd8cf34f.svg";